// extracted by mini-css-extract-plugin
export var aboutSec = "style-module--aboutSec--e645d";
export var blog_items = "style-module--blog_items--b7887";
export var blog_textarea_empty = "style-module--blog_textarea_empty--dd966";
export var blogsec = "style-module--blogsec--7677b";
export var btn = "style-module--btn--0fc68";
export var btn_border_shadow = "style-module--btn_border_shadow--d76a1";
export var btn_border_shadow__color2 = "style-module--btn_border_shadow__color2--26f69";
export var card = "style-module--card--dd300";
export var center = "style-module--center--508ef";
export var classSec = "style-module--classSec--56e96";
export var color = "style-module--color--35476";
export var container = "style-module--container--1b985";
export var content = "style-module--content--69691";
export var day = "style-module--day--9586f";
export var en = "style-module--en--a46eb";
export var flowSec = "style-module--flowSec--1b01d";
export var gradeBlock = "style-module--gradeBlock--aaa94";
export var gradeTitle = "style-module--gradeTitle--09994";
export var header = "style-module--header--bcfaf";
export var innerWrap = "style-module--innerWrap--80c4e";
export var intermap = "style-module--intermap--e6081";
export var interview = "style-module--interview--bf4d9";
export var interviewSec = "style-module--interviewSec--0e0b4";
export var item = "style-module--item--382da";
export var kv_ttl = "style-module--kv_ttl--36c0b";
export var label = "style-module--label--51158";
export var linkSec = "style-module--linkSec--d26e3";
export var link_faq = "style-module--link_faq--7adb7";
export var link_inner = "style-module--link_inner--1207d";
export var link_recruit = "style-module--link_recruit--231a7";
export var more_btn = "style-module--more_btn--75ee5";
export var name = "style-module--name--a4f3e";
export var nameBox = "style-module--nameBox--a4e25";
export var offTime = "style-module--offTime--b29ae";
export var pdfPreview = "style-module--pdfPreview--2aa50";
export var photo = "style-module--photo--05b97";
export var photoBox = "style-module--photoBox--cee31";
export var row = "style-module--row--4a39c";
export var scheduleBoard = "style-module--scheduleBoard--4b04b";
export var scheduleBoard_test = "style-module--scheduleBoard_test--deaf0";
export var scheduleCards = "style-module--scheduleCards--34f3d";
export var scheduleGrid = "style-module--scheduleGrid--e4556";
export var scheduleWrapper = "style-module--scheduleWrapper--2290d";
export var schedulesec = "style-module--schedulesec--490d2";
export var section_description = "style-module--section_description--98e8a";
export var subject = "style-module--subject--af35d";
export var textBox = "style-module--textBox--4eafa";
export var time = "style-module--time--b733b";
export var topSec = "style-module--topSec--0533f";
export var top_Backwrap = "style-module--top_Backwrap--582e7";
export var top_pen = "style-module--top_pen--b2dcd";
export var top_visual_media_outer = "style-module--top_visual_media_outer--b112e";
export var top_wrap = "style-module--top_wrap--7ed46";
export var value = "style-module--value--ef5ef";
export var youTubeBox = "style-module--youTubeBox--154a9";
export var youtubeItem = "style-module--youtubeItem--baa7a";
export var youtubeSec = "style-module--youtubeSec--158f1";
export var youtubebtn = "style-module--youtubebtn--7c489";
export var youtubecontent = "style-module--youtubecontent--d3d1c";
export var youtubeinner = "style-module--youtubeinner--d9cfa";